import { render } from "./RoadmapView.vue?vue&type=template&id=dc5f44c2&scoped=true&ts=true"
import script from "./RoadmapView.vue?vue&type=script&lang=ts"
export * from "./RoadmapView.vue?vue&type=script&lang=ts"

import "./RoadmapView.vue?vue&type=style&index=0&id=dc5f44c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5f44c2"]])

export default __exports__